import { Music } from 'lucide-react';
import SuccessModal from './SuccessModal';

interface SubmissionSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  songTitle: string;
  artist: string;
}

export default function SubmissionSuccessModal({
  isOpen,
  onClose,
  songTitle,
  artist,
}: SubmissionSuccessModalProps) {
  const trackCard = (
    <div className="bg-white/5 border border-white/10 rounded-lg p-4">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <Music className="w-5 h-5 text-white/60" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-white font-medium truncate">{songTitle}</p>
          <p className="text-white/60 text-sm truncate">{artist}</p>
        </div>
      </div>
    </div>
  );

  return (
    <SuccessModal
      isOpen={isOpen}
      onClose={onClose}
      title="Submission received"
      subtitle="Thank you for sharing music that matters."
      middleContent={trackCard}
      body="Our team will review your submission and consider adding it to the civicbeat catalogue. Each story is curated to ensure it meets our standards for civic engagement and musical significance."
    />
  );
}
